import React from 'react';
import {Theme, withStyles} from '@material-ui/core/styles';

import{PaperProps} from '@material-ui/core/Paper';
import {Paper} from "@material-ui/core";
import {
  OptionDarkWithBackdrop,
  OptionDarkWithNoBackdrop,
  OptionLightWithBackdrop,
  OptionLightWithNoBackdrop
} from './WaxPaperOptions';

const backdropSupport = CSS.supports('(-webkit-backdrop-filter: blur(40px)) or (backdrop-filter: blur(40px))');

const styles = (theme: Theme) => {
  const themeDark = (theme.palette.type === 'dark');
  if (backdropSupport && themeDark) {
    return OptionDarkWithBackdrop(theme);
  } else if (backdropSupport && !themeDark) {
    return OptionLightWithBackdrop(theme);
  } else if (!backdropSupport && themeDark) {
    return OptionDarkWithNoBackdrop(theme);
  } else {
    return OptionLightWithNoBackdrop(theme);
  }
};

interface WaxPaperProps extends PaperProps {
  classes: Record<string, string>;
  theme: Theme;
  multi?: boolean;
}

const getClass = (theme: Theme) => {
  const themeDark = (theme.palette.type === 'dark');
  if (backdropSupport && themeDark) {
    return OptionDarkWithBackdrop(theme);
  } else if (backdropSupport && !themeDark) {
    return OptionLightWithBackdrop(theme);
  } else if (!backdropSupport && themeDark) {
    return OptionDarkWithNoBackdrop(theme);
  } else {
    return OptionLightWithNoBackdrop(theme);
  }
};

class WaxPaper extends React.Component<WaxPaperProps>{
  render() {
    const { classes: { root, rootWithChildren }, multi, theme, elevation, ...others } = this.props;
    const e = backdropSupport && (theme.palette.type === 'dark') ? 0 : elevation;
    const toApply = multi ? rootWithChildren : root;
    return (
      <Paper {...others} classes={{ root: toApply }} elevation={e} />
    );
  }
}

export { getClass };

// @ts-ignore
export default withStyles(styles, { withTheme: true })(WaxPaper);
